import { render } from "./SvgUse.vue?vue&type=template&id=3e285cb7"
import script from "./SvgUse.vue?vue&type=script&lang=js"
export * from "./SvgUse.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__